import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipComponent } from './tip.component';



@NgModule({
  declarations: [
    TipComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TipComponent
  ]
})
export class TipModule { }
